export const ACTION_OPEN_MAIN_DRAWER = 'ACTION_OPEN_MAIN_DRAWER';
export const ACTION_CLOSE_MAIN_DRAWER = 'ACTION_CLOSE_MAIN_DRAWER';
export const ACTION_OPEN_TOOLBAR = 'ACTION_OPEN_TOOLBAR';
export const ACTION_CLOSE_TOOLBAR = 'ACTION_CLOSE_TOOLBAR';
export const ACTION_OPEN_LEFT_FLOATING_DRAWER =
  'ACTION_OPEN_LEFT_FLOATING_DRAWER';
export const ACTION_CLOSE_LEFT_FLOATING_DRAWER =
  'ACTION_CLOSE_LEFT_FLOATING_DRAWER';
export const ACTION_OPEN_RIGHT_FLOATING_DRAWER =
  'ACTION_OPEN_RIGHT_FLOATING_DRAWER';
export const ACTION_CLOSE_RIGHT_FLOATING_DRAWER =
  'ACTION_CLOSE_RIGHT_FLOATING_DRAWER';
export const ACTION_RESET = 'ACTION_RESET';
export const ACTION_LEFT_DRAWER_OPEN = 'ACTION_LEFT_DRAWER_OPEN';
export const ACTION_LEFT_DRAWER_CLOSE = 'ACTION_LEFT_DRAWER_CLOSE';
export const ACTION_LEFT_DRAWER_JSX = 'ACTION_LEFT_DRAWER_JSX';
export const ACTION_RIGHT_DRAWER_OPEN = 'ACTION_RIGHT_DRAWER_OPEN';
export const ACTION_RIGHT_DRAWER_CLOSE = 'ACTION_RIGHT_DRAWER_CLOSE';
export const ACTION_RIGHT_DRAWER_JSX = 'ACTION_RIGHT_DRAWER_JSX';
export const PASS_JSX = 'PASS_JSX';
export const ACTION_DARK_MODE = 'ACTION_DARK_MODE';
export const ACTION_FORCE_SET_DARK_MODE = 'ACTION_FORCE_SET_DARK_MODE';
export const ACTION_SET_TOOLBAR_JSX = 'ACTION_SET_TOOLBAR_JSX';
export const ACTION_SET_APPBAR_JSX = 'ACTION_SET_APPBAR_JSX';
export const ACTION_MAIN_DRAWER = 'ACTION_MAIN_DRAWER';
export const ACTION_MAIN_DRAWER_NOT = 'ACTION_MAIN_DRAWER_NOT';
export const ACTION_MAIN_APP_BAR = 'ACTION_MAIN_APP_BAR';
export const ACTION_MAIN_APP_BAR_NOT = 'ACTION_MAIN_APP_BAR_NOT';
export const ACTION_MAIN_BOTTOM_BAR = 'ACTION_MAIN_BOTTOM_BAR';
export const ACTION_MAIN_BOTTOM_BAR_NOT = 'ACTION_MAIN_BOTTOM_BAR_NOT';
export const ACTION_MAIN_BOTTOM_BAR_JSX = 'ACTION_MAIN_BOTTOM_BAR_JSX';
export const ACTION_CLOSE_ALL_DRAWER = 'ACTION_CLOSE_ALL_DRAWER';
export const ACTION_RESET_FLOATING_DRAWER = 'ACTION_RESET_FLOATING_DRAWER';
export const ACTION_OPEN_NOTIFICATION_DRAWER =
  'ACTION_OPEN_NOTIFICATION_DRAWER';
export const ACTION_CLOSE_NOTIFICATION_DRAWER =
  'ACTION_CLOSE_NOTIFICATION_DRAWER';
export const ACTION_AB_BB_TB_RF_LF = 'ACTION_AB_BB_TB_RF_LF';
export const ACTION_FORCE_SET_LIGHT_MODE = 'ACTION_FORCE_SET_LIGHT_MODE';
export const RIGHT_DRAWER_WIDTH = 'RIGHT_DRAWER_WIDTH';
